import { __decorate, __extends } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import SignUpContract from '@/views/components/signUpContract/index.vue';

var SignContract = function (_super) {
  __extends(SignContract, _super);

  function SignContract() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  SignContract = __decorate([Component({
    components: {
      SignUpContract: SignUpContract
    }
  })], SignContract);
  return SignContract;
}(Vue);

export default SignContract;